'use strict';

exports.__esModule = true;
exports.default = QuMapAbstract;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _immutable = require('immutable');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _quMapAbstract = require('./qu-map-abstract.helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var filterQuiqee = function filterQuiqee(geoJson) {
  return function (quiqee) {
    geoJson = geoJson || [];
    geoJson = Array.isArray(geoJson) ? geoJson : [geoJson];
    var quiqeesInGeoJson = geoJson.filter(function (json) {
      return json.properties && json.properties.transportMode;
    });

    var isImmutable = _immutable.Iterable.isIterable(quiqee);
    var lastLocation = isImmutable ? quiqee.get('lastLocation') : quiqee.lastLocation;

    if (!lastLocation) {
      return false;
    }

    var id = isImmutable ? quiqee.get('id') : quiqee.id;
    var isInGeoJson = quiqeesInGeoJson.find(function (feature) {
      return feature.properties.id === id;
    });
    return !isInGeoJson;
  };
};

var toArray = function toArray(data) {
  if (_immutable.List.isList(data)) {
    return data.toJS();
  }
  if (_immutable.Iterable.isIterable(data)) {
    return [data.toJS()];
  }
  return Array.isArray(data) ? data : [data];
};

var toFeatureCollection = function toFeatureCollection() {
  var features = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return { type: 'FeatureCollection', features: features };
};

function QuMapAbstract(_ref) {
  var quiqees = _ref.quiqees,
      waypoints = _ref.waypoints,
      geoJson = _ref.geoJson,
      children = _ref.children;

  var quiqeesFeatures = toArray(quiqees).filter(filterQuiqee(geoJson)).map(function (wp) {
    return (0, _quMapAbstract.createFeature)(wp, _quMapAbstract.TYPE.QUIQEE);
  });

  var wpOptions = { withPositionBadge: waypoints.length > 2 || waypoints.size > 2 };
  var waypointsFeatures = toArray(waypoints).map(function (wp) {
    return (0, _quMapAbstract.createFeature)(wp, _quMapAbstract.TYPE.WAYPOINT, wpOptions);
  });

  var allFeatures = toArray(geoJson).concat(waypointsFeatures).concat(quiqeesFeatures);

  var mapGeoJson = allFeatures.length > 0 ? toFeatureCollection(allFeatures) : undefined;
  return children(mapGeoJson);
}

var immutableAndPlainPropTypes = [_propTypes2.default.array, _propTypes2.default.object, _reactImmutableProptypes2.default.list, _reactImmutableProptypes2.default.map];

QuMapAbstract.propTypes = {
  geoJson: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  quiqees: _propTypes2.default.oneOfType(immutableAndPlainPropTypes),
  waypoints: _propTypes2.default.oneOfType(immutableAndPlainPropTypes),
  children: _propTypes2.default.func.isRequired
};

QuMapAbstract.defaultProps = {
  quiqees: [],
  waypoints: []
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/qu-react-sdk/lib/components/qu-map/qu-map-abstract/qu-map-abstract.js
// module id = 862
// module chunks = 0